import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiPricingConfigGet } from '@/entities/pricing/modules/api/pricing';

export const usePricingConfig = () =>
  useFetch({
    api: () => apiPricingConfigGet(),
    keywords: queryKeys.pricing,
    staleTime: 60_000,
  });
